export const NOTIFICATION_PAGE_SIZE = 50;
/** Server FEED_MAX_SIZE — stop asking after this many loaded cards. */
export const NOTIFICATION_FEED_MAX_SIZE = 200;

export function feedCursor(items = []) {
  const last = items[items.length - 1];
  if (!last?.timestamp) {
    return undefined;
  }
  return last.timestamp instanceof Date
    ? last.timestamp.toISOString()
    : last.timestamp;
}

export function appendFeedPage(currentItems = [], pageItems = []) {
  const seen = new Set(currentItems.map((item) => item._id).filter(Boolean));
  return [
    ...currentItems,
    ...pageItems.filter((item) => item?._id && !seen.has(item._id)),
  ];
}

export function mergeEventIdMaps(current = {}, next = {}) {
  const merged = { ...current };
  Object.keys(next).forEach((assetId) => {
    const existing = merged[assetId] || [];
    const incoming = next[assetId] || [];
    merged[assetId] = [
      ...existing,
      ...incoming.filter((id) => !existing.includes(id)),
    ];
  });
  return merged;
}

export function nextHasMore(pageLength, totalLength) {
  return pageLength === NOTIFICATION_PAGE_SIZE
    && totalLength < NOTIFICATION_FEED_MAX_SIZE;
}
